module.exports = __webpack_public_path__ + "static/media/HomeGraphic7.33085347.jpg";